import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 9l6 6","key":"svg-1"}]]

const IconForbid = createReactComponent('outline', 'forbid', 'Forbid', __iconNode);

export default IconForbid;